const parseExperienceId = () => {
	let parts = window.location.pathname.split("/");
	if (parts[3] === "experiences") {
		return parts[4];
	} else {
		return undefined;
	}
};

export default parseExperienceId;
